import React, { useContext } from "react";
import authContext from "../../contexts/auth/authContext";
import "./home.scss";

const HomeIndex = (props) => {
    const auth = useContext(authContext);

    const login = () => {
        auth.initiateLogin();
    };
    const logout = () => {
        auth.logout();
    };

    const loginButton = auth.authenticated ? (
        <button className="button" onClick={logout}>
            Log Out
        </button>
    ) : (
        <button className="button -primary" onClick={login}>
            Log In
        </button>
    );

    return (
        <div className="home container txt-center">
            <h1>INTAKE</h1>
            {loginButton}
        </div>
    );
};

export default HomeIndex;
